import React from 'react';
import { FaUsers } from "react-icons/fa";

const ServiceCardDetails = ({
  icon = <FaUsers className="text-onInfoVariant text-2xl" />,
  title = "",
  description = [],
  imgSrc = ""
}) => {
  return (
    <div className="flex items-center gap-6 rounded-xl px-6 py-4 bg-customSurface h-full" >
      <div>
        {imgSrc ? (
          <img src={imgSrc} alt="Service Icon" className="w-12 h-12" />
        ) : (
          icon
        )}

      </div>
      <div>
        <h6 className="Medium text-onInfoVariant mb-1">{title}</h6>
        {Array.isArray(description) ? (
          <ul className="list-disc list-inside ml-5 text-onInfoVariant body">
            {description.map((item, idx) => (
              <li key={idx} >{item}</li>
            ))}
          </ul>
        ) : (
          <div className="text-onInfoVariant body">{description}</div>
        )}
      </div>
    </div>
  );
};

export default ServiceCardDetails;